export default "__VITE_ASSET__fEJj2pfY__"